module.exports = __webpack_public_path__ + "static/img/001.188930d0.png";